module.exports = __webpack_public_path__ + "img/15.34c13285.png";